import { OrdersModel } from '@app/core/models';
import { OrdersActions, OrdersActionTypes } from '../actions/orders.actions';

/**
 * OrdersState
 */
export interface OrdersState {
  loaded: boolean;
  pending: boolean;
  error: any;
  orders: OrdersModel[];
  ordersOpen: OrdersModel[];
  ordersDelayed: OrdersModel[];
  ordersAttn: OrdersModel[];
  ordersCompleted: OrdersModel[];
}

/**
 * ORDERS_INITIAL_STATE
 * @type {{loaded: boolean; pending: boolean; error: null; orders: any[]; ordersOpen: any[]; ordersDelayed: any[]; ordersAttn: any[]; ordersCompleted: any[]}}
 */
export const ORDERS_INITIAL_STATE: OrdersState = {
  loaded: false,
  pending: false,
  error: null,
  orders: [],
  ordersOpen: [],
  ordersDelayed: [],
  ordersAttn: [],
  ordersCompleted: [],
};

/**
 * ordersReducer
 * @param {OrdersState} state
 * @param {OrdersActions} action
 * @returns {OrdersState}
 */
export const ordersReducer = (state: OrdersState = ORDERS_INITIAL_STATE, action: OrdersActions): OrdersState => {
  switch (action.type) {
    case OrdersActionTypes.LOAD_ORDERS:
      return {
        ...state,
        error: null,
        loaded: false,
        pending: true,
      };
    case OrdersActionTypes.LOAD_ORDERS_SUCCESS:
      return {
        ...state,
        loaded: true,
        pending: false,
        orders: action.payload,
        ordersOpen: action.payload.filter((o) => {
          return o.orderStatus === 'Open' || o.orderStatus === 'Needs Attention' || o.orderStatus === 'Delayed';
        }),
        ordersAttn: action.payload.filter((o) => {
          return o?.frameDetails?.frameStatus === 'Exception Occurred' || o.orderStatus === 'Needs Attention';
        }),
        ordersDelayed: action.payload.filter((o) => {
          return o.orderStatus === 'Delayed';
        }),
        ordersCompleted: action.payload.filter((o) => {
          return o.orderStatus === 'Complete';
        }),
      };
    case OrdersActionTypes.LOAD_ORDERS_ERROR:
      return {
        ...state,
        loaded: true,
        pending: false,
        error: action.payload,
      };
    case OrdersActionTypes.LOAD_ORDERS_OPEN:
      return {
        ...state,
        ordersOpen: action.payload,
      };
    case OrdersActionTypes.LOAD_ORDERS_DELAYED:
      return {
        ...state,
        ordersDelayed: action.payload,
      };
    case OrdersActionTypes.LOAD_ORDERS_ATTN:
      return {
        ...state,
        ordersAttn: action.payload,
      };
    case OrdersActionTypes.LOAD_ORDERS_COMPLETED:
      return {
        ...state,
        ordersCompleted: action.payload,
      };
    default:
      return state;
  }
};
